import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../react-auth0-spa";

import { API_URL } from "../../constants/constants";

export const useGetPaquetes = () => {
  // console.log(initialUser);
  const [user, setUser] = useState(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user: user2 } = useAuth0();

  useEffect(() => {
    if (!user2) return;
    const fetchPaquetes = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const t = await getTokenSilently();
        const r = await axios.get(API_URL + `/paquetes/${user2.sub}`, {
          headers: {
            // "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${t}`
          }
        });
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchPaquetes();
  }, [user,getTokenSilently,user2]);

  return [{ data, isLoading, isError }, setUser];
};

export default useGetPaquetes;
